import * as S from "./styles";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import ptBr from "date-fns/locale/pt-BR";
import { InputAdornment } from "@mui/material";
import { BiCalendarEvent } from "react-icons/bi";
import React from "react";
import { Control, Controller, FieldValues, Path } from "react-hook-form";
import { format, parseISO } from "date-fns";

interface DatePickerProps<T extends FieldValues>
  extends React.ComponentProps<typeof MobileDatePicker> {
  iconOnly?: boolean;
  control: Control<T>;
  inputName: Path<T>;
}

export default function FutDatePicker<T extends FieldValues>({
  inputName,
  control,
  iconOnly,
  ...props
}: DatePickerProps<T>) {
  return (
    <Controller
      name={inputName}
      control={control}
      render={({ field } :any) => (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBr}>
          <S.StyledMuiDatePicker
            {...field}
            slotProps={{
              textField: {
                InputProps: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <BiCalendarEvent />
                    </InputAdornment>
                  ),
                },
                size: "small",
              },
            }}
            iconOnly={iconOnly}
            {...props}
          />
        </LocalizationProvider>
      )}
    />
  );
}
